//Market place Config

export const MARKET_CONFIG = "https://shopv2.betalearnings.com/";
export const KEY_CLOAK_URL = "https://login.betachat.betalearnings.com/auth/";
export const GOOGLE_CLIENT_ID =
  "828565342140-hssdtcntis0pklgeedtaqlgkougiinas.apps.googleusercontent.com";
export const CLIENT_ID = "Betachatweb";
export const profiles = null;
export const ENCRYPT_KEY = "B";
export const DYNAMIC_FORM_URL = "https://forms.yuukke.com/yuukke";
// export const CLIENT_ID = "iwn-mobile";
// export const profiles = "moodle,keycloak";
